import { TAssetOperationTypeEnum } from '@/shared/hooks/use-assets-app-sync-events/use-assets-app-sync-events.types';
import { documentsApi } from '@/shared/redux/api/assets/documents/documents-api';
import { useAppDispatch } from '@/shared/redux/hooks/hooks';

export const useInvalidateDocumentTags = () => {
  const dispatch = useAppDispatch();

  const invalidateDocumentTags = (
    documentId: string,
    operationType: TAssetOperationTypeEnum,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          documentsApi.util.invalidateTags([
            { type: 'Document', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
      case TAssetOperationTypeEnum.AssetUpdated:
        dispatch(
          documentsApi.util.invalidateTags([
            { type: 'Document', id: documentId },
            { type: 'Document', id: 'LIST' },
            'Groups' as const,
          ]),
        );
        break;
    }
  };

  const invalidateDocumentVersionTags = (
    documentId: string,
    operationType: TAssetOperationTypeEnum,
  ) => {
    switch (operationType) {
      case TAssetOperationTypeEnum.AssetCreated:
      case TAssetOperationTypeEnum.AssetDeleted:
        dispatch(
          documentsApi.util.invalidateTags([
            { type: 'Document', id: 'LIST' },
            { type: 'Document', id: documentId },
            { type: 'DocumentVersions', id: documentId },
            'Groups' as const,
          ]),
        );
        break;
      default:
        dispatch(
          documentsApi.util.invalidateTags([
            { type: 'Document', id: 'LIST' },
            { type: 'Document', id: documentId },
            { type: 'DocumentVersions', id: documentId },
          ]),
        );
        break;
    }
  };

  return {
    invalidateDocumentTags,
    invalidateDocumentVersionTags,
  };
};
